<template>
    <div class="admin-edit">
        <v-container>
            <v-row>
                <v-col cols="12">
                    <v-card class="mt-8">
                        <v-card-title class="dark--text subtitle-1 font-weight-bold">
                            <v-btn
                                depressed
                                rounded
                                class="secondary mx-2"
                                dark
                                @click="() => $router.go(-1)"
                            >
                                <v-icon>keyboard_arrow_left</v-icon>
                            </v-btn>
                            ပြင်ဆင်ရန်
                            <v-spacer></v-spacer>
                            <v-btn
                                rounded
                                depressed
                                class="primary"
                                @click="updateData"
                                large
                                dark
                                :loading="loading"
                            >
                                <v-icon>save</v-icon>
                                သိမ်းမည်
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="mt-3">
                            <v-row>
                                <v-col cols="12" md="4">
                                    <p class="dark--text body-2 font-weight-bold">အမည် -</p>
                                    <v-text-field
                                        solo
                                        background-color="grey lighten-2"
                                        flat
                                        rounded
                                        class="dark--text"
                                        v-model="name"
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="dark--text body-2 font-weight-bold">အီးမေးလ် -</p>
                                    <v-text-field
                                        solo
                                        background-color="grey lighten-2"
                                        flat
                                        rounded
                                        class="dark--text"
                                        v-model="email"
                                        type="email"
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="dark--text body-2 font-weight-bold">အဆင့် -</p>
                                    <v-select
                                        solo
                                        background-color="grey lighten-2"
                                        flat
                                        rounded
                                        class="dark--text"
                                        :items="roles"
                                        item-text="name"
                                        item-value="value"
                                        v-model="role"
                                    />
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="dark--text body-2 font-weight-bold">ဖုန်း -</p>
                                    <v-text-field
                                        solo
                                        background-color="grey lighten-2"
                                        flat
                                        rounded
                                        class="dark--text"
                                        v-model="phone"
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import Admin from "../../api/model/Admin";
export default {
    name: "AdminEdit",
    data: function () {
        return {
            adminId: this.$route.params.adminId,
            loading: false,
            name: null,
            email: null,
            phone: null,
            role: null,
            oldPassword: null,
            newPassword: null,
            roles: [
                {
                    name: "Super အက်ဒမင်",
                    value: 0,
                },
                {
                    name: "အက်ဒမင်",
                    value: 1,
                },
                {
                    name: "Sales အက်ဒမင်",
                    value: 2,
                },
                {
                    name: "အက်ဒီတာ",
                    value: 3,
                },
            ],
        };
    },
    methods: {
        updateData: async function () {
            this.loading = true;
            // Obj to update
            var adminObj = {
                name: this.name,
                email: this.email,
                phone: this.phone,
                role: this.role,
                password: this.oldPassword,
            };
            // Check if password should include or not
            //if (!this.newPassword) delete adminObj["password"];
            if (this.newPassword) {
                adminObj.password = this.newPassword;
            }
            try {
                await Admin.updateInfo(this.adminId, adminObj, this.token);
                this.$router.push("/admins");
            } catch (err) {
                this.loading = false;
                console.log("Error : ", err);
                this.$store.dispatch("MAKE_ERROR", "Cannot update admin !");
            }
        },
        getAdminData: async function () {
            try {
                let result = await Admin.getInfo(this.adminId, this.token);
                console.log(result);
                // Assigning
                this.name = result.name;
                this.email = result.email;
                this.phone = result.phone;
                (this.role = result.role), (this.oldPassword = result.password);
            } catch (err) {
                console.log("Error : ", err);
                this.$store.dispatch("MAKE_ERROR", "Cannot get admin data !");
            }
        },
    },
    created: async function () {
        // get the data of current admin
        await this.getAdminData();
    },

    computed: {
        token: function () {
            return this.$store.state.user.token;
        },
    },
};
</script>
